<template>
  <div class="ShowRfRemote lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="ShowRfRemote-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="ShowRfRemote-main lxn-pos-rel">
      <div class="ShowRfRemote-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox titleBgColor="#dedede" bgColor="#ececec">
          <template v-slot:title>
            <span style="color: #000000;">{{output.name}}</span>
          </template>
          <template v-slot:body>
            <div style="height: 20px;"></div>
            <div class="lxn-w100 lxn-overflow-hidden">
              <div class="ShowRfRemote-button lxn-circle lxn-float-left" @click="channelClicked(0)">
                <ButtonIcon :size="70" bgColor="#f0ebe8" icon="one" iconColor="#51616e" :padding="10" :isRound="true" borderColor="#56c2f0" :borderWidth="5" :onclickEffect="true" />
              </div>
              <div class="ShowRfRemote-button lxn-circle lxn-float-left" @click="channelClicked(1)">
                <ButtonIcon :size="70" bgColor="#f0ebe8" icon="two" iconColor="#51616e" :padding="10" :isRound="true" borderColor="#56c2f0" :borderWidth="5" :onclickEffect="true" />
              </div>
              <div class="ShowRfRemote-button lxn-circle lxn-float-left" @click="channelClicked(2)">
                <ButtonIcon :size="70" bgColor="#f0ebe8" icon="three" iconColor="#51616e" :padding="10" :isRound="true" borderColor="#56c2f0" :borderWidth="5" :onclickEffect="true" />
              </div>
              <div class="ShowRfRemote-button lxn-circle lxn-float-left" @click="channelClicked(3)">
                <ButtonIcon :size="70" bgColor="#f0ebe8" icon="four" iconColor="#51616e" :padding="10" :isRound="true" borderColor="#56c2f0" :borderWidth="5" :onclickEffect="true" />
              </div>
            </div>
          </template>
        </TitleBox>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ButtonIcon from '@/components/ButtonIcon.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import TitleBox from '@/components/TitleBox.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import NODE8 from '@/statics/devices/Node8/header.js'


export default {
  name: 'ShowRfRemote',
  components: {
    CustomCurve,
    TopNav,
    TitleBox,
    ButtonIcon
  },
  data: function () {
    return {
      node: this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID),
      nodeUUID: Math.floor(this.$route.params.nodeUUID),
      outputIndex: Math.floor(this.$route.params.outputIndex),
    }
  },
  watch: {
  },
  computed: {
    hub: function () {
      return this.$store.getters.getHubByUUID(this.node.hubUUID);
    },
    output: function () {
      return this.node.outputs[this.$route.params.outputIndex];
    },
    targetDevice: function () {
      return NODE8.devices[this.output.settings.deviceType];
    },
    targetDeviceId: function () {
      return this.output.settings.deviceId;
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    channelClicked: function (channel) {
      this.$store.commit('setAppBusy', true);
      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: this.hub.psk,
        destinationUUID: this.hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });
      var endSeq = [0, 0];
      if(this.targetDevice.endThrUs != 0){
        endSeq = [this.targetDevice.highThrUs, this.targetDevice.endThrUs];
      }
      var channelPacket = [...this.targetDeviceId, ...this.targetDevice.channels[channel]];

      var rfPacket = messagingHook.irf.generateIrfByteStream(messagingHook.irf.generateRawData(channelPacket, this.targetDevice.lowThrUs, this.targetDevice.highThrUs, this.targetDevice.startSeq, endSeq));

      this.$store.dispatch('setNodesParameters', {
        messagingHook: messagingHook,
        hubUUID: this.hub.uuid,
        nodeUUID: this.node.uuid,
        bodyContent: {
          nodeActions: [
            {
              nodeUUID: this.node.uuid,
              actions: [
                {
                  parameterId: NODE8.RF.PARAMETER_ID,
                  valueOfChange: messagingHook.utility.arrayTo64(rfPacket),
                  typeOfAction: CONFIGS.ACTION_TYPE_SET,
                  timeDelay: 0
                }
              ]
            },
          ]
        }
      })
      .then( () => {
        this.$store.commit('setAppBusy', false);
      })
      .catch( response => {
        if(response.rejectCode == 1){
          this.$router.push('/SettingsNodeError');
        }else if(response.rejectCode == 2){
          this.$router.push('/SettingsHubError');
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
        this.$store.commit('setAppBusy', false);
      });
    },
  }
}
</script>

<style>
  .ShowRfRemote-topCurve-wrapper {
    height: 200px;
  }
  .ShowRfRemote-main {
    z-index: 2;
  }
  .ShowRfRemote-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .ShowRfRemote-button {
    margin-left: calc(33.33% - 45px);
    margin-bottom: 30px;
    width: 70px;
    height: 70px;
  }
</style>
